import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NotButton, NotInput } from '@nebalkon-workspace/ui-kit';
import { CabinetButtonComponent } from '@nebalkon-workspace/cabinet-client';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-warehouse-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FormsModule, NotInput, CabinetButtonComponent, NotButton],
  templateUrl: './staff-order-detail-warehouse-panel.component.html',
  styleUrl: './staff-order-detail-panels.component.scss',
})
export class StaffOrderDetailWarehousePanelComponent {
  readonly facade = inject(StaffOrderDetailFacade);
}
